export default __webpack_public_path__ + "static/media/midfield-circle.66f99e1e.svg";